<template lang="pug">
search-desktop(v-if="q.platform.is.desktop")
search-mobile(v-if="q.platform.is.mobile")
</template>

<script>
import { deepCopy } from 'assets/helpers';
import { useQuasar, LoadingBar, useMeta } from 'quasar';
import { useRoute } from 'vue-router';
import { getValid_In } from 'assets/helpers/blackListCitys';
import { computed, watchEffect } from 'vue';
import { useStore } from 'vuex';

import { getModificationFilters, getFiltersFromURL } from './helpers/helpers';
import SearchDesktop from './SearchDesktop.vue';
import SearchMobile from './SearchMobile.vue';

export default {
    name: 'Search',
    async preFetch({ store, currentRoute, previousRoute, redirect }) {

        if (previousRoute && previousRoute?.name != 'search') {
            store.commit('search/SET_EXIT_ROUTE', previousRoute?.fullPath);
        }
        ;

        if (!currentRoute.query.query)
            return void redirect({ path: '/' });

        LoadingBar.setDefaults({
            color: 'positive',
            size: '4px',
            position: 'top',
        });
        LoadingBar.start();

        // начало загрузки
        store.commit('search/SET_LOADING', true);

        const oldFilters = store.getters['search/FILTERS_FROM_URL'];

        // получаем фильтры из URL
        const filtersFromURL = getFiltersFromURL(currentRoute?.query);

        // запрос предыдущего query запроса
        const searchQuery = store.getters['search/SEARCH_QUERY'];

        // отслеживание изменения фильтров
        const filtersChanange = JSON.stringify(JSON.parse(JSON.stringify(oldFilters))) != JSON.stringify(filtersFromURL);

        const sortChange = currentRoute.query.sort != previousRoute?.query.sort;

        const searchMethodChange = currentRoute?.query?.noTerm != previousRoute?.query?.noTerm;

        // сравнение предыдущего query запроса с текущим
        if (searchQuery != currentRoute.query.query || filtersChanange || sortChange || searchMethodChange || previousRoute.city != currentRoute.city)
            store.commit('search/SET_SEARCH_SCROLL_ID', null);

        // сохраняем query нового запроса, для отслеживания его измения
        store.commit('search/SET_SEARCH_QUERY', currentRoute.query.query);

        // скрываем блок "сбросить фильтры"
        store.commit('productList/SET_SHOW_RESET', false);

        // сохраняем полученные фильтры
        store.commit('search/SET_FILTERS_FROM_URL', filtersFromURL);

        const scrollId = store.getters['search/SCROLL_ID'];

        let data = {
            'filter': {
                'filters': [],
            },
        };

        // вычисление применяемых фильтров
        for (const [category, filter] of Object.entries(filtersFromURL)) {
            let currentFilter = { 'key': category, 'value': filter[0] };
            data.filter.filters.push(currentFilter);
        }

        if (currentRoute.query.sort) {
            let currentSort = { 'sort': { 'sort': currentRoute.query.sort } };
            Object.assign(data, currentSort);
        }

        let newResult = null;

        if (currentRoute.query.noTerm) {
            newResult = await store.dispatch('search/NEW_SEARCH', {
                query: currentRoute.query.query,
                page: currentRoute.query.page || 1,
                size: currentRoute.query.limit || 20,
                scrollId: scrollId || null,
                data,
            });
        } else {
            newResult = await store.dispatch('search/NEW_SEARCH_TERM', {
                query: currentRoute.query.query,
                page: currentRoute.query.page || 1,
                size: currentRoute.query.limit || 20,
                scrollId: scrollId || null,
                data,
            });
        }

        store.commit('search/SET_SEARCH_NRESULT', newResult.products);
        store.commit('search/SET_SEARCH_NRESULTS_COUNT', newResult.totalCount);
        store.commit('search/SET_SEARCH_NRESULT_FILTERS', newResult.filters);
        store.commit('search/SET_SEARCH_SCROLL_ID', newResult.scrollId);
        store.commit('search/SET_SEARCH_REGIONS', newResult.regions);

        store.commit('search/SET_LOADING', false);

        await store.dispatch('advertisement/GET_MARKERS');

        LoadingBar.stop();
    },
    components: {
        SearchMobile,
        SearchDesktop,
    },
    setup() {
        const router = useRoute();
        const store = useStore();

        const city = computed(() => store.getters['cityForm/CITY']);

        watchEffect(() => {
            useMeta({
                title: `Лекарственные препараты ${router.query.query} купить в ${getValid_In(city?.value?.name ? city.value.name : 'Белгород')} с доставкой в аптеку или на дом | Интернет-аптека eTabl.ru (партнер Таблеточка)`,
                meta: {
                    description: {
                        name: 'description',
                        content: `Лекарственные препараты ${router.query.query} купить в онлайн-аптеке eTabl.ru (партнер Таблеточка). Низкие цены ✅ Доставка на дом и в аптеку в ${getValid_In(city?.value?.name ? city.value.name : 'Белгород')} ✅ Гарантия качества ✅ Удобный поиск ☎️ 8 (800) 200-5-400"`,
                    },
                    googlebot: {
                        name: 'googlebot',
                        content: 'noindex',
                    },
                },
                link: [
                    { rel: 'canonical', href: `https://${process.env.APP_SERVICE_HOSTNAME}/search` },
                ],
            });

            if (process.env.CLIENT) {
                // window._paq.push(['trackGoal', 2]);
            }
        });

        return {
            q: useQuasar(),
        };
    },
};
</script>
